import { rootApi } from "../../api/rootApi";

export const printerTemplateMappingApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    createTemplateMapping: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/printer-template-mapping/add`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
            // No Content-Type header — browser will set multipart/form-data with boundary automatically
          },
          body: params.body, // FormData
        };
      },
    }),
    fetchAllTemplateMappings: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/printer-template-mapping/all`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    updateTemplateMappingById: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/printer-template-mapping/${params.id}`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
            // No Content-Type header — browser will set multipart/form-data with boundary automatically
          },
          body: params.body, // FormData
        };
      },
    }),
    deleteTemplateMappingById: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/tenant/printer-template-mapping/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    fetchTemplateMappingByCategoryId: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/printer-template-mapping/by-category/${params.categoryId}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const {
  useCreateTemplateMappingMutation,
  useFetchAllTemplateMappingsMutation,
  useUpdateTemplateMappingByIdMutation,
  useDeleteTemplateMappingByIdMutation,
  useFetchTemplateMappingByCategoryIdMutation,
} = printerTemplateMappingApi;
